import axios from "axios";
import store from "@/store";
import Cookies from "js-cookie";
import router from "./../router";
import { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import { POR_LOGIN_LOGOUT } from "./config";

export const requestData = (methods, url, datas, headers, timeout) => {
  //封装请求方法
  let headerObj = {};

  headerObj = {
    "Content-Type": "application/json",
    Authorization: "Basic c2FiZXI6c2FiZXJfc2VjcmV0",
    applet: "3",
    i18n: localStorage.getItem("locale") || "zh",
    "blade-auth": store.state.userInfo.access_token
      ? "bearer " + store.state.userInfo.access_token
      : ""
  };

  if (!datas) datas = {};

  let options = Object.assign(
    {},
    {
      url: url,
      method: methods,
      baseURL: POR_LOGIN_LOGOUT, // config 的 base_url
      timeout: 15000, // 超时
      headers: Object.assign(headers || {}, headerObj)
    }
  );
  if (methods == "get") {
    options.params = datas;
  } else if (methods == "post") {
    options.data = datas;
  } else if (methods == "put") {
    options.params = datas;
  } else if (methods == "delete") {
    options.params = datas;
  }
  if (headers) {
    options.headers = headers;
  }
  if (timeout) {
    options.timeout = timeout;
  }

  let listPromise = new Promise((resolve, reject) => {
    axios
      .request(options)
      .then(res => {
        resolve(res.data);
      })
      .catch(res => {
        reject(res);
      });
  });
  return listPromise;
};

axios.interceptors.request.use(
  //请求拦截
  config => {
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  function(res) {
    if (res.data.code == 401) {
      console.log("登陆失败");
      loginFunc();
    } else if (res.data.code == 601) {
      router.push("/auth");
    } else if (res.data.code == 602) {
      router.push("/userAuth");
    }
    return res;
  },
  function(error) {
    if (error.response.status == 401) {
      loginFunc();
    }
  }
);
console.log("Message====", Message);
const loginFunc = () => {
  Message.closeAll();
  Message({
    message: "登陆过期,请重新登陆...",
    type: "error",
    center: true,
    onClose: function() {
      // Cookies.remove("userInfo");
      store.commit("quitLogin");
      router.replace({
        path: "/login?type=3"
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/request/request.js